import React from 'react';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import { ReportSectionTypes } from '../redux/constants';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '../ReportPage.scss';
const ReportIpViolation = ({ onChange })=>{
    return /*#__PURE__*/ React.createElement("ul", {
        className: s['section']
    }, /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.FirstPartyIp,
        label: 'This is my intellectual property',
        subLabel: 'I am the copyright owner',
        onChange: (e)=>onChange(ReportSectionTypes.FirstPartyIp)
    }), /*#__PURE__*/ React.createElement(ListItemRadioButton, {
        name: "option",
        value: ReportSectionTypes.ThirdPartyIp,
        label: 'This is someone else’s intellectual property',
        subLabel: 'This deviation is using someone else’s content without permission',
        onChange: (e)=>onChange(ReportSectionTypes.ThirdPartyIp)
    }));
};
ReportIpViolation.displayName = 'ReportIpViolation';
export default ReportIpViolation;

//# sourceMappingURL=ReportIpViolation.js.map